import CorporateChargerDetails from '../../components/Corporates/CorporateChargerDetails';
import {
  useDisableChargerMutation,
  useEnableChargerMutation,
} from '../../utils/queries/corporateChargers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useFetchCorporateChargerByID } from '../../utils/queries/corporateChargers';
import { ExclamationCircleOutlined, LeftOutlined } from '@ant-design/icons';
import { Button, Typography, Tabs, Badge, Tag, message } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import { get } from 'lodash-es';
import { useState } from 'react';
import ChargerAnalytics from 'components/Corporates/ChargerAnalytics';
import './style.css';

const { TabPane } = Tabs;

const { Title } = Typography;

const useStyles = createUseStyles({
  onlineOfflineBadgeIcon: {
    '& .ant-badge-status-dot': {
      height: '11px',
      width: '11px',
    },
  },
  chargerControlsCollapse: {
    width: '100%',
    '& .ant-collapse-header': {
      fontWeight: 'bold',
    },
  },
});

export default function CorporateCharger({ corporateId, cpid, chargerMapId }) {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();

  // const [selectedTab, setSelectedTab] = useQueryParam(
  //   'tab',
  //   withDefault(StringParam, 'details'),
  // );
  const [selectedTab, setSelectedTab] = useState('details');
  const { data, isLoading, refetch } =
    useFetchCorporateChargerByID(chargerMapId);
  const [isConfirmDisableVisible, setConfirmDisableVisible] = useState(false);
  const initiatedDisableCharger = useDisableChargerMutation();
  const initiatedEnableCharger = useEnableChargerMutation();
  async function enableCharger() {
    try {
      await initiatedEnableCharger.mutateAsync(chargerMapId);
      refetch();
      message.success(`Charger ${cpid} is enabled successfully`);
      setTimeout(() => message.destroy(), 3000);
    } catch (error) {
      message.error(`Something went wrong: ${error?.response?.data?.error}`);
    }
  }

  function confirmDisableCharger() {
    setConfirmDisableVisible(true);
  }

  async function submitDisableCharger() {
    try {
      await initiatedDisableCharger.mutateAsync(chargerMapId);
      setConfirmDisableVisible(false);
      refetch();
      message.success(`Charger ${cpid} is disabled successfully`);
      setTimeout(() => message.destroy(), 3000);
    } catch (error) {
      message.error(`Something went wrong: ${error?.response?.data?.error}`);
    }
  }

  const closeConfirmDisable = () => {
    setConfirmDisableVisible(false);
  };

  const setClickedMonthIndex = () => {};

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          <LeftOutlined
            style={{ marginRight: '10px', cursor: 'pointer' }}
            onClick={() => history.goBack()}
          />
          <Title level={2} style={{ margin: '0px' }}>
            Charger{' '}
            <span style={{ color: '#2375b8' }}>
              {location.pathname.indexOf('/corporate/charger/detail/') > -1
                ? get(data?.data, 'JP_CORPORATE_CHARGER.CHARGER')
                : cpid}
            </span>
          </Title>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          {data?.data?.IS_ENABLED === 0 ? (
            <Button
              type="primary"
              size="large"
              style={{ marginLeft: '10px' }}
              onClick={() => enableCharger()}
            >
              Enable
            </Button>
          ) : (
            <Button
              type="primary"
              size="large"
              style={{ marginLeft: '10px' }}
              onClick={() => confirmDisableCharger()}
            >
              Disable
            </Button>
          )}
        </div>
      </div>
      <div>
        <Badge
          status={data?.data?.IS_AVAILABLE ? 'processing' : 'error'}
          color={data?.data?.IS_AVAILABLE ? '#52c41a' : '#f94d4f'}
          className={classes.onlineOfflineBadgeIcon}
        />
        <Tag color={data?.data?.IS_AVAILABLE ? 'green' : 'volcano'}>
          {data?.data?.IS_AVAILABLE ? 'Online' : 'Offline'}
        </Tag>
      </div>
      <Tabs
        activeKey={selectedTab}
        onTabClick={(key) => {
          setSelectedTab(key);
        }}
        className="w-full"
      >
        <TabPane tab="Details" key="details">
          <CorporateChargerDetails
            corporateId={corporateId}
            cp={data?.data}
            cpid={cpid}
            isChargerLoading={isLoading}
          />
        </TabPane>
        <TabPane tab="Analytics" key="analytics">
          <ChargerAnalytics
            chargerId={cpid}
            setClickedMonthIndex={() => setClickedMonthIndex()}
          />
        </TabPane>
      </Tabs>

      {/******************** Confirm DisableCharger ********************************/}

      <Modal isOpen={isConfirmDisableVisible} toggle={closeConfirmDisable}>
        <ModalHeader
          style={{ padding: '5px 10px', margin: 10 }}
          toggle={closeConfirmDisable}
        >
          Confirm
        </ModalHeader>
        <ModalBody>
          <div style={{ fontSize: '16px' }}>
            <ExclamationCircleOutlined
              style={{ fontSize: '24px', marginRight: 10 }}
            />
            After disabling the Charger, it won't be able to connect with the
            Central System
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            style={{ color: '#fff', background: '#6c757d' }}
            onClick={() => closeConfirmDisable()}
            // loading={isLoading || isLoadingUpdate}
            // disabled={isLoading || isLoadingUpdate}
          >
            <span>Cancel</span>
          </Button>
          <Button
            style={{ color: '#fff', background: '#1890ff' }}
            onClick={() => submitDisableCharger()}
            // loading={isLoading || isLoadingUpdate}
            // disabled={isLoading || isLoadingUpdate}
          >
            <span>OK</span>
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
